module.exports = __webpack_public_path__ + "img/satellite.e81f739b.png";